import EventService from '../react-components/CalculationComponents/calculationComponents.eventservice';
import { AUTOSAVE } from '../react-components/StatsbidragSubmitAction/StatsbidragSubmitAction';
import _ from 'lodash';
import { nameIsEpiFormField, STR_FIELD, STR_CC, STR_C } from '../helpers/stb.helpers';
import formDataEntries from 'form-data-entries';
import Console from 'sos-common/js/utils/console.log';

/**
 * The form will be saved automatically every 5 seconds if there's a change in form-data.
 */
export function initializeAutosave(form: HTMLFormElement) {
  let oldFormData = filterFormData(formDataEntries(form));
  Console.log('autosave initialized');
  // Repeat autosave after 5000ms
  setInterval(() => {
    let newFormData = filterFormData(formDataEntries(form));
    // Only fire an autosave event if the formdata differs from last time
    if (!_.isEqual(oldFormData, newFormData)) {
      Console.log('executing autosave');
      EventService.fire(`form-submit-action`, { detail: AUTOSAVE });
      oldFormData = newFormData;
    }
  }, 5000);
}

function filterFormData(formData: [string, FormDataEntryValue][]) {
  return formData.filter((x) => x[0].startsWith(STR_FIELD) || x[0].startsWith(STR_CC) || x[0].startsWith(STR_C));
}
